import React, { useState } from "react";
import {
  Button,
  Modal,
  Box,
  Typography,
  TextField,
  Snackbar,
  IconButton,
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CloseIcon from "@mui/icons-material/Close";

function ExportDialog({ buttonLabel = "Exportar Lista", title = "Exportar", onExport }) {
  const [open, setOpen] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [exportPath, setExportPath] = useState("");
  const [showSnackbar, setShowSnackbar] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleExport = () => {
    const path = onExport(startDate, endDate); // função passada pela tela que usa
    setExportPath(path);
    setShowSnackbar(true);
    setOpen(false);
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(exportPath);
  };

  return (
    <>
      {/* Botão para abrir modal */}
      <Button
        variant="contained"
        sx={{
          background: "linear-gradient(90deg, #1976D2 0%, #42A5F5 100%)",
          color: "#fff",
          fontWeight: "bold",
          textTransform: "uppercase",
          borderRadius: "12px",
          padding: "8px 20px",
          boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.16)",
          "&:hover": {
            background: "linear-gradient(90deg, #1565c0 0%, #1e88e5 100%)",
          },
        }}
        onClick={handleOpen}
      >
        {buttonLabel}
      </Button>

      {/* Modal */}
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            p: 4,
            borderRadius: 2,
            boxShadow: 24,
            width: 400,
          }}
        >
          {/* Botão de fechar (X) no canto superior direito */}
          <IconButton
            onClick={handleClose}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>

          <Typography variant="h6" mb={2}>
            {title}
          </Typography>

          <TextField
            label="Data Inicial"
            type="date"
            fullWidth
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
            sx={{ mb: 2 }}
          />

          <TextField
            label="Data Final"
            type="date"
            fullWidth
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
            sx={{ mb: 2 }}
          />

          <Button
            variant="contained"
            sx={{
                background: "linear-gradient(90deg, #1976D2 0%, #42A5F5 100%)",
                color: "#fff",
                fontWeight: "bold",
                textTransform: "uppercase",
                borderRadius: "12px",
                padding: "8px 20px",
                boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.16)",
                "&:hover": {
                    background: "linear-gradient(90deg, #1565c0 0%, #1e88e5 100%)",
                },
            }}
            fullWidth
            onClick={handleExport}
          >
            Exportar
          </Button>
        </Box>
      </Modal>

      {/* Snackbar com diretório */}
      <Snackbar
        open={showSnackbar}
        autoHideDuration={8000}
        onClose={() => setShowSnackbar(false)}
        message={
          <span>
            Arquivo exportado para: <strong>{exportPath}</strong>
            <IconButton size="small" onClick={handleCopy}>
              <ContentCopyIcon fontSize="small" />
            </IconButton>
          </span>
        }
        action={
          <IconButton
            size="small"
            color="inherit"
            onClick={() => setShowSnackbar(false)}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        }
      />
    </>
  );
}

export default ExportDialog;
